import * as React from 'react';
import * as _ from 'lodash';
import PagerEx from '../../../components/PageLayout/PagerEx';
import CheckBox from '../../../components/PageLayout/CheckBox';
import * as helpers from '../../../utilities/helpers';
import * as Misc from '../../../misc';
export default function () {
    function onClick1(featureGroup, featureGroupIndex, e) {
        this.selectFeatureGroup(e, featureGroup);
    }
    function onClick2(featureGroup, featureGroupIndex, e) {
        Misc.ignoreDefault(e);
    }
    function onChecked3(featureGroup, featureGroupIndex) {
        this.props.toggleFeatureGroup(featureGroup);
    }
    function repeatFeatureGroup4(featureGroup, featureGroupIndex) {
        return [React.createElement('li', {
                'className': 'assign-sidebar-list__item ' + (this.props.selectedFeatureGroup == featureGroup ? 'assign-sidebar-list__item--active' : ''),
                'onClick': onClick1.bind(this, featureGroup, featureGroupIndex),
                'key': '4521'
            }, React.createElement('div', {
                'className': 'feature-inclusion-assign__checkbox',
                'onClick': onClick2.bind(this, featureGroup, featureGroupIndex)
            }, React.createElement(CheckBox, {
                'onChecked': onChecked3.bind(this, featureGroup, featureGroupIndex),
                'checked': this.isGroupChecked(featureGroup),
                'text': true
            })), React.createElement('div', {
                'className': 'assign-sidebar-list__item-image',
                'style': { backgroundImage: 'url(\'' + helpers.getFeatureGroupIconURL(featureGroup, this.isGroupChecked(featureGroup)) + '\')' }
            }), React.createElement('span', { 'className': 'assign-sidebar-list__item-title' }, featureGroup))];
    }
    function onChecked5(feature, featureIndex) {
        this.props.checkFeature(feature);
    }
    function repeatFeature6(feature, featureIndex) {
        return [React.createElement('li', {
                'className': 'assign-features__item ' + (this.props.selectedFeatureGroup != 'Edge Profile' ? 'assign-features__item-rectangle' : ''),
                'key': '14601'
            }, React.createElement('div', { 'className': 'assign-card__checkbox' }, React.createElement(CheckBox, {
                'onChecked': onChecked5.bind(this, feature, featureIndex),
                'checked': this.isFeatureChecked(feature),
                'text': true
            })), React.createElement('div', {
                'className': 'assign-features__item-image feature-inclusion-assign-features__item-image',
                'style': { backgroundImage: 'url(\'https://s3.amazonaws.com/features_thumbnails/feature-' + feature.imageKey + '.png\')' }
            }), React.createElement('div', { 'className': 'assign-features__item-text' }, this.getFeatureName(feature.name)))];
    }
    return React.createElement('div', { 'className': 'app-content-main' }, React.createElement('aside', { 'className': 'assign-sidebar feature-inclusion-content-aside' }, React.createElement.apply(this, [
        'ul',
        { 'className': 'assign-sidebar-list' },
        _.map(this.props.featureGroups, repeatFeatureGroup4.bind(this))
    ])), React.createElement('div', { 'className': 'assign-container feature-inclusion-content-view' }, React.createElement.apply(this, [
        'ul',
        { 'className': 'assign-features' },
        _.map(this.props.features, repeatFeature6.bind(this))
    ]), this.props.totalPages > 1 ? React.createElement(PagerEx, {
        'pageCount': this.props.totalPages,
        'forcePage': this.props.page,
        'onPageChange': page => this.props.setPage(page),
        'key': '2272'
    }) : null));
}